export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/toyo-82ea3ce6a16d1632ba8ae424b9fa9eec.png";